import type { TranslationKey } from "@/i18n";

export const socialStrings = {
  navHome: "social.navigation.home",
  navCues: "social.navigation.cues",
  navInbox: "social.navigation.inbox",
  navProfile: "social.navigation.profile",
  someone: "social.notifications.someone",
  someoneNearby: "social.notifications.someoneNearby",
  smallGroup: "social.notifications.smallGroup",
  cueReceivedTitle: "social.notifications.cueReceivedTitle",
  cueReceivedBody: "social.notifications.cueReceivedBody",
  cueAcceptedTitle: "social.notifications.cueAcceptedTitle",
  cueAcceptedBody: "social.notifications.cueAcceptedBody",
  messageTitle: "social.notifications.messageTitle",
  messageBody: "social.notifications.messageBody",
  groupMessageTitle: "social.notifications.groupMessageTitle",
  groupMessageBody: "social.notifications.groupMessageBody",
  morePeopleTitle: "social.notifications.morePeopleTitle",
  onePersonTitle: "social.notifications.onePersonTitle",
  morePeopleBody: "social.notifications.morePeopleBody",
  onePersonBody: "social.notifications.onePersonBody",
  revealRequestedTitle: "social.notifications.revealRequestedTitle",
  revealRequestedBody: "social.notifications.revealRequestedBody",
  revealCompletedTitle: "social.notifications.revealCompletedTitle",
  revealCompletedBody: "social.notifications.revealCompletedBody",
  received: "social.cues.received",
  receivedA11y: "social.cues.receivedA11y",
  sent: "social.cues.sent",
  sentA11y: "social.cues.sentA11y",
  newRequests: "social.cues.newRequests",
  viewProfile: "social.cues.viewProfile",
  accept: "social.cues.accept",
  acceptA11y: "social.cues.acceptA11y",
  ignore: "social.cues.ignore",
  ignoreA11y: "social.cues.ignoreA11y",
  block: "safety.block",
  blockA11y: "social.cues.blockA11y",
  waiting: "social.cues.waiting",
  waitingBody: "social.cues.waitingBody",
  acceptedBadge: "social.cues.acceptedBadge",
  openChat: "social.cues.openChat",
  withdraw: "social.cues.withdraw",
  withdrawA11y: "social.cues.withdrawA11y",
  withdrawConfirmTitle: "social.cues.withdrawConfirmTitle",
  withdrawConfirmBody: "social.cues.withdrawConfirmBody",
  withdrawConfirm: "social.cues.withdrawConfirm",
  withdrawFailed: "social.cues.withdrawFailed",
  slotsHelp: "social.cues.slotsHelp",
  cooldownCancelled: "social.cues.cooldownCancelled",
  cooldownExpired: "social.cues.cooldownExpired",
  cuesEmptyTitle: "social.cues.emptyTitle",
  cuesEmptyBody: "social.cues.emptyBody",
  active: "social.inbox.active",
  activeCount: "social.inbox.activeCount",
  practiceTitle: "social.inbox.practiceTitle",
  openPracticeA11y: "social.inbox.openPracticeA11y",
  practiceDescription: "social.inbox.practiceDescription",
  practicePrivate: "social.inbox.practicePrivate",
  openConversationA11y: "social.inbox.openConversationA11y",
  openGroupA11y: "social.inbox.openGroupA11y",
  people: "social.inbox.people",
  hereFor: "social.inbox.hereFor",
  noLongerActive: "social.inbox.noLongerActive",
  tabActive: "social.inbox.tabActive",
  tabInactive: "social.inbox.tabInactive",
  tabActiveA11y: "social.inbox.tabActiveA11y",
  tabInactiveA11y: "social.inbox.tabInactiveA11y",
  // Open to chat. A strict subset of Active, so its strings live beside the
  // Active ones rather than in a namespace of their own.
  tabOpen: "social.inbox.tabOpen",
  tabOpenA11y: "social.inbox.tabOpenA11y",
  openHeading: "social.inbox.openHeading",
  openEmpty: "social.inbox.openEmpty",
  openEmptyBody: "social.inbox.openEmptyBody",
  openImOpen: "social.inbox.openImOpen",
  openImOpenFor: "social.inbox.openImOpenFor",
  openImOpenA11y: "social.inbox.openImOpenA11y",
  openTurnOffA11y: "social.inbox.openTurnOffA11y",
  openDurationTitle: "social.inbox.openDurationTitle",
  openDurationMinutes: "social.inbox.openDurationMinutes",
  openDurationHour: "social.inbox.openDurationHour",
  openDurationHours: "social.inbox.openDurationHours",
  openPeerA11y: "social.inbox.openPeerA11y",
  openFailedTitle: "social.inbox.openFailedTitle",
  openFailedBody: "social.inbox.openFailedBody",
  inactivePreview: "social.inbox.inactivePreview",
  inboxInactiveWarning: "social.inbox.inactiveWarning",
  reopenWaiting: "social.inbox.reopenWaiting",
  reopenAsked: "social.inbox.reopenAsked",
  inactiveEmptyTitle: "social.inbox.inactiveEmptyTitle",
  inactiveEmptyBody: "social.inbox.inactiveEmptyBody",
  sayHi: "social.inbox.sayHi",
  groupPreview: "social.inbox.groupPreview",
  inboxEmptyTitle: "social.inbox.emptyTitle",
  inboxEmptyBody: "social.inbox.emptyBody",
  chatViewProfileA11y: "social.chat.viewProfileA11y",
  revealedStatus: "social.chat.revealedStatus",
  publicProfile: "social.chat.publicProfile",
  chatYou: "social.chat.you",
  chatThem: "social.chat.them",
  requestReveal: "social.chat.requestReveal",
  acceptReveal: "social.chat.acceptReveal",
  conversationOptionsA11y: "social.chat.optionsA11y",
  revealed: "social.chat.revealed",
  revealedDetails: "social.chat.revealedDetails",
  revealPending: "social.chat.revealPending",
  revealReceived: "social.chat.revealReceived",
  revealPendingShort: "social.chat.revealPendingShort",
  connected: "social.chat.connected",
  messagesUnavailable: "social.chat.messagesUnavailable",
  closed: "social.chat.closed",
  peerUnavailable: "social.chat.peerUnavailable",
  peerGone: "social.chat.peerGone",
  chatInactiveWarning: "social.chat.inactiveWarning",
  inactiveTitle: "social.chat.inactiveTitle",
  inactiveBody: "social.chat.inactiveBody",
  blockedTitle: "social.chat.blockedTitle",
  blockedBody: "social.chat.blockedBody",
  unblock: "social.chat.unblock",
  unblockConfirmTitle: "social.chat.unblockConfirmTitle",
  unblockConfirmBody: "social.chat.unblockConfirmBody",
  leftTitle: "social.chat.leftTitle",
  leftBody: "social.chat.leftBody",
  resume: "social.chat.resume",
  reopenAsk: "social.chat.reopenAsk",
  reopenPending: "social.chat.reopenPending",
  reopenCooldown: "social.chat.reopenCooldown",
  reopenRequestTitle: "social.chat.reopenRequestTitle",
  reopenRequestBody: "social.chat.reopenRequestBody",
  reopenAccept: "social.chat.reopenAccept",
  reopenDecline: "social.chat.reopenDecline",
  reopenFailedTitle: "social.chat.reopenFailedTitle",
  reopenFailedBody: "social.chat.reopenFailedBody",
  replyingTo: "social.chat.replyingTo",
  replyingToAuthor: "social.chat.replyingToAuthor",
  cancelReplyA11y: "social.chat.cancelReplyA11y",
  messagePlaceholder: "social.chat.messagePlaceholder",
  closeOptionsA11y: "social.chat.closeOptionsA11y",
  close: "common.close",
  revealDescription: "social.chat.revealDescription",
  photoExchange: "social.chat.photoExchange",
  photoExchangeHint: "social.chat.photoExchangeHint",
  photoExchanged: "social.chat.photoExchanged",
  photoExchangedHint: "social.chat.photoExchangedHint",
  photoRespond: "social.chat.photoRespond",
  photoRespondHint: "social.chat.photoRespondHint",
  photoWaiting: "social.chat.photoWaiting",
  photoWaitingHint: "social.chat.photoWaitingHint",
  photoExhaustedHint: "social.chat.photoExhaustedHint",
  photoRequestTitle: "social.chat.photoRequestTitle",
  photoRequestBody: "social.chat.photoRequestBody",
  photoShareBack: "social.chat.photoShareBack",
  photoNotNow: "social.chat.photoNotNow",
  photoWithdraw: "social.chat.photoWithdraw",
  photoRejectedTitle: "social.chat.photoRejectedTitle",
  photoRejectedBody: "social.chat.photoRejectedBody",
  photoGoneTitle: "social.chat.photoGoneTitle",
  photoGoneBody: "social.chat.photoGoneBody",
  photoUnavailable: "social.chat.photoUnavailable",
  photoRetry: "social.chat.photoRetry",
  photoOpenA11y: "social.chat.photoOpenA11y",
  photoDelete: "social.chat.photoDelete",
  photoDeleteTitle: "social.chat.photoDeleteTitle",
  photoDeleteBody: "social.chat.photoDeleteBody",
  clearMessages: "social.chat.clearMessages",
  loadEarlier: "social.chat.loadEarlier",
  /** The outbox's one marker, and the refusal when its bounds are reached. */
  messagePending: "social.chat.messagePending",
  messageQueueFullTitle: "social.chat.messageQueueFullTitle",
  messageQueueFullBody: "social.chat.messageQueueFullBody",
  loadingEarlier: "social.chat.loadingEarlier",
  clearDescription: "social.chat.clearDescription",
  clearConfirmTitle: "social.chat.clearConfirmTitle",
  clearConfirmBody: "social.chat.clearConfirmBody",
  clearConfirm: "social.chat.clearConfirm",
  clearedTitle: "social.chat.clearedTitle",
  clearedBody: "social.chat.clearedBody",
  exitQuietly: "social.chat.exitQuietly",
  exit: "social.chat.exit",
  exitDescription: "social.chat.exitDescription",
  blockTitle: "social.chat.blockTitle",
  blockDescription: "social.chat.blockDescription",
  cancel: "common.cancel",
  report: "safety.report",
  reportDescription: "social.chat.reportDescription",
  typingA11y: "social.chat.typingA11y",
  reactA11y: "social.chat.reactA11y",
  removeReactionA11y: "social.chat.removeReactionA11y",
  reactWithA11y: "social.chat.reactWithA11y",
  pickEmojiA11y: "social.chat.pickEmojiA11y",
  emojiSearch: "social.chat.emojiSearch",
  emojiNone: "social.chat.emojiNone",
  emojiPickerClose: "social.chat.emojiPickerClose",
  deckOpenA11y: "social.conversationDeck.openA11y",
  deckTitle: "social.conversationDeck.title",
  deckSubtitle: "social.conversationDeck.subtitle",
  deckCloseA11y: "social.conversationDeck.closeA11y",
  deckCategoryA11y: "social.conversationDeck.categoryA11y",
  deckPlusLockTitle: "social.conversationDeck.plusLock.title",
  deckPlusLockBody: "social.conversationDeck.plusLock.body",
  deckPlusLockBody2: "social.conversationDeck.plusLock.body2",
  deckPlusLockCta: "social.conversationDeck.plusLock.cta",
  deckPlusLockDismiss: "social.conversationDeck.plusLock.dismiss",
  deckPlusLockedA11y: "social.conversationDeck.plusLock.lockedA11y",
  deckCategorySelectedA11y: "social.conversationDeck.categorySelectedA11y",
  deckMore: "social.conversationDeck.more",
  deckMoreA11y: "social.conversationDeck.moreA11y",
  deckLess: "social.conversationDeck.less",
  deckLessA11y: "social.conversationDeck.lessA11y",
  deckPromptBadge: "social.conversationDeck.promptBadge",
  deckPromptBadgeStart: "social.conversationDeck.promptBadges.start",
  deckPromptBadgeKeepGoing: "social.conversationDeck.promptBadges.keep_going",
  deckPromptBadgeFun: "social.conversationDeck.promptBadges.fun",
  deckPromptBadgeGetToKnow: "social.conversationDeck.promptBadges.get_to_know",
  deckPromptBadgeGoDeeper: "social.conversationDeck.promptBadges.go_deeper",
  deckPromptBadgeMakeAPlan: "social.conversationDeck.promptBadges.make_a_plan",
  deckPromptBadgeWrapUp: "social.conversationDeck.promptBadges.wrap_up",
  deckPromptHint: "social.conversationDeck.promptHint",
  deckAddToMessage: "social.conversationDeck.addToMessage",
  deckAddToMessageA11y: "social.conversationDeck.addToMessageA11y",
  deckAnother: "social.conversationDeck.another",
  deckAnotherA11y: "social.conversationDeck.anotherA11y",
  deckPhraseMyself: "social.conversationDeck.phraseMyself",
  deckDraftTitle: "social.conversationDeck.draftTitle",
  deckDraftBody: "social.conversationDeck.draftBody",
  deckReplaceDraft: "social.conversationDeck.replaceDraft",
  deckReplaceDraftA11y: "social.conversationDeck.replaceDraftA11y",
  deckAddAfterDraft: "social.conversationDeck.addAfterDraft",
  deckAddAfterDraftA11y: "social.conversationDeck.addAfterDraftA11y",
  deckCancelDraft: "social.conversationDeck.cancelDraft",
  deckFollowUpPossibleIfAnswered:
    "social.conversationDeck.followUp.possibleIfAnswered",
  deckFollowUpA11y: "social.conversationDeck.followUp.a11y",
  deckCategoryStart: "social.conversationDeck.categories.start",
  deckCategoryKeepGoing: "social.conversationDeck.categories.keep_going",
  deckCategoryFun: "social.conversationDeck.categories.fun",
  deckCategoryGetToKnow: "social.conversationDeck.categories.get_to_know",
  deckCategoryGoDeeper: "social.conversationDeck.categories.go_deeper",
  deckCategoryMakeAPlan: "social.conversationDeck.categories.make_a_plan",
  deckCategoryWrapUp: "social.conversationDeck.categories.wrap_up",
  groupEndedTitle: "social.groups.endedTitle",
  groupEndedBody: "social.groups.endedBody",
  groupUpdateFailedTitle: "social.groups.updateFailedTitle",
  tryAgain: "common.tryAgain",
  backHomeA11y: "social.groups.backHomeA11y",
  groupOptionsA11y: "social.groups.menu.open",
  groupSummary: "social.groups.summary",
  leave: "social.groups.leave",
  endsSoon: "social.groups.endsSoon",
  endsIn: "social.groups.endsIn",
  groupEmpty: "social.groups.empty",
  suggestSpot: "social.groups.suggestSpot",
  ready: "social.groups.ready",
  groupMessagePlaceholder: "social.groups.messagePlaceholder",
  menuMembers: "social.groups.menu.members",
  menuInvite: "social.groups.menu.invite",
  menuRange: "social.groups.menu.range",
  rangeTitle: "social.groups.range.title",
  rangeHint: "social.groups.range.hint",
  rangeDone: "social.groups.range.done",
  inviteShareMessage: "social.groups.invite.shareMessage",
  inviteEyebrow: "social.groups.invite.eyebrow",
  inviteMembers: "social.groups.invite.members",
  inviteRange: "social.groups.invite.range",
  inviteJoin: "social.groups.invite.join",
  inviteOpen: "social.groups.invite.open",
  inviteBrowse: "social.groups.invite.browse",
  inviteTryAgain: "social.groups.invite.tryAgain",
  inviteMissingTitle: "social.groups.invite.missingTitle",
  inviteMissingBody: "social.groups.invite.missingBody",
  inviteOutOfRangeTitle: "social.groups.invite.outOfRangeTitle",
  inviteOutOfRangeBody: "social.groups.invite.outOfRangeBody",
  inviteFullTitle: "social.groups.invite.fullTitle",
  inviteFullBody: "social.groups.invite.fullBody",
  inviteEndedTitle: "social.groups.invite.endedTitle",
  inviteEndedBody: "social.groups.invite.endedBody",
  inviteNotVisibleTitle: "social.groups.invite.notVisibleTitle",
  inviteNotVisibleBody: "social.groups.invite.notVisibleBody",
  inviteNoLocationTitle: "social.groups.invite.noLocationTitle",
  inviteNoLocationBody: "social.groups.invite.noLocationBody",
  inviteRemovedTitle: "social.groups.invite.removedTitle",
  inviteRemovedBody: "social.groups.invite.removedBody",
  menuSuggestMeetupSpot: "social.groups.menu.suggestMeetupSpot",
  menuLeaveGroup: "social.groups.menu.leaveGroup",
  menuDeleteGroup: "social.groups.menu.deleteGroup",
  endedBanner: "social.groups.ended.banner",
  endedDeleteConfirmTitle: "social.groups.ended.deleteConfirmTitle",
  endedDeleteConfirmAction: "social.groups.ended.deleteConfirmAction",
  endedPreview: "social.groups.ended.preview",
  menuReportGroup: "social.groups.menu.reportGroup",
  closeGroupOptionsA11y: "social.groups.menu.closeA11y",
  membersSheetTitle: "social.groups.members.title",
  hostLabel: "social.groups.members.hostLabel",
  groupViewProfile: "social.groups.members.viewProfile",
  removeMember: "social.groups.members.remove",
  reportMember: "social.groups.members.report",
  memberOnly: "social.groups.members.onlyYou",
  memberActions: "social.groups.members.actions",
  memberMessage: "social.groups.members.message",
  memberCue: "social.groups.members.cue",
  memberCueUnavailable: "social.groups.members.cueUnavailable",
  memberCueSent: "social.groups.members.cueSent",
  cueConsentTitle: "social.groups.members.consentTitle",
  cueConsentHint: "social.groups.members.consentHint",
  removeConfirmTitle: "social.groups.remove.confirmTitle",
  removeConfirmBody: "social.groups.remove.confirmBody",
  removeConfirmAction: "social.groups.remove.confirmAction",
  removeSuccess: "social.groups.remove.success",
  removedTitle: "social.groups.removed.title",
  removedBody: "social.groups.removed.body",
  removedClose: "social.groups.removed.close",
  removedReport: "social.groups.removed.report",
  // Prefixed because the one-to-one thread already owns `leftTitle`/`leftBody`
  // in this same map — a quiet exit from a chat, which says something different.
  groupLeftTitle: "social.groups.left.title",
  groupLeftBody: "social.groups.left.body",
  groupLeftRejoin: "social.groups.left.rejoin",
  groupLeftNotice: "social.groups.left.notice",
  leaveConfirmTitle: "social.groups.leaveConfirm.title",
  leaveConfirmBody: "social.groups.leaveConfirm.body",
  leaveHostConfirmBody: "social.groups.leaveConfirm.hostBody",
  leaveConfirmAction: "social.groups.leaveConfirm.action",
  reportGroupTitle: "social.groups.report.title",
  meetupEasyToFind: "social.groups.meetup.easyToFind",
  meetupQuieter: "social.groups.meetup.quieter",
  meetupCustom: "social.groups.meetup.custom",
  meetupDraftNearEntrance: "social.groups.meetup.drafts.nearEntrance",
  meetupDraftEasyToFind: "social.groups.meetup.drafts.easyToFind",
  meetupDraftQuieter: "social.groups.meetup.drafts.quieter",
  meetupDraftCustom: "social.groups.meetup.drafts.custom",
  meetupDraftConflictTitle: "social.groups.meetup.draftConflict.title",
  meetupDraftConflictReplace: "social.groups.meetup.draftConflict.replace",
  meetupDraftConflictAppend: "social.groups.meetup.draftConflict.append",
  meetupDraftConflictCancel: "social.groups.meetup.draftConflict.cancel",
  profileUnavailableTitle: "social.groups.profileUnavailable.title",
  profileUnavailableBody: "social.groups.profileUnavailable.body",
  closeSpotsA11y: "social.groups.closeSpotsA11y",
  suggestSpotTitle: "social.groups.suggestSpotTitle",
  nearEntrance: "social.groups.nearEntrance",
  byCounter: "social.groups.byCounter",
  atMyTable: "social.groups.atMyTable",
  custom: "social.groups.custom",
  ownSpot: "social.groups.ownSpot",
  customSpotPlaceholder: "social.groups.customSpotPlaceholder",
  sendCustomA11y: "social.groups.sendCustomA11y",
  send: "social.groups.send",
  oneTyping: "social.groups.oneTyping",
  manyTyping: "social.groups.manyTyping",
  you: "social.groups.you",
} as const satisfies Record<string, TranslationKey>;

/**
 * Cues, conversations, inbox, Small Groups, realtime notifications, and tab
 * navigation. Cue is the product action; Reveal means mutual profile sharing,
 * not exposing private information. Small Groups are temporary and nearby.
 * Names, messages, group names, and user-authored meetup spots are interpolated
 * or displayed unchanged.
 */
